import { render, staticRenderFns } from "./VacationRequest.vue?vue&type=template&id=461dd1d2&scoped=true&"
import script from "./VacationRequest.vue?vue&type=script&lang=js&"
export * from "./VacationRequest.vue?vue&type=script&lang=js&"
import style0 from "./VacationRequest.vue?vue&type=style&index=0&id=461dd1d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461dd1d2",
  null
  
)

export default component.exports